import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { SharedModule } from '@app/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';

import { ChangeStepService } from '@app/core/components/stepper/service/change-step.service';
import { ChangeDeviceService } from '@app/shared/services/change-device.service';

import { SelectButtonOptionClickEvent } from 'primeng/selectbutton';
import { SaveDataService } from '@app/shared/services/save-data.service';
import { CoreModule } from '@app/core/core.module';
import { AppService } from '@app/app.service';
import { HouseType } from '@app/shared/interfaces/common-data/house-type';
import { PersonalDataService } from '@app/shared/services/common-data/personal-data.service';

@Component({
    selector: 'app-type',
    standalone: true,
    imports: [CoreModule, CommonModule, SharedModule, TranslateModule],
    templateUrl: './house-type.component.html',
    styleUrl: './house-type.component.scss',
})
export class HouseTypeComponent {

	private appData = inject(AppService);

    continueButton = 'common.buttons.continueButton';
    backButton = 'common.buttons.backButton';

    houseTypeTitle = 'features.housing.houseType.houseTypeTitle';
    houseTypeSubtitle = 'features.housing.houseType.houseTypeSubtitle';

    moreOptions = 'features.housing.houseType.moreOptions';
    lessOptions = 'features.housing.houseType.lessOptions';

    ownerButton = 'features.housing.houseType.owner';
    rentButton = 'features.housing.houseType.rent';

    yearFloatLabel = 'features.housing.houseType.yearFloatLabel';
    infoYear = 'features.housing.houseType.infoYear';

    costFloatLabel = 'features.housing.houseType.costFloatLabel';
    infoCost = 'features.housing.houseType.infoCost';

    backButtonDisabled = false;
    continueButtonDisabled = true;
    showMoreHouseType = false;

    isPortraitDevice = false;

    formGroup!: FormGroup;

    typeHousingOptions : HouseType[] | undefined;
    houseTypes : HouseType[] | undefined;
    houseTypesExtra : HouseType[] | undefined;

    selectedTypeHousingContract!: HouseType;

    constructor(
        private saveDataService: SaveDataService,
        private route: ActivatedRoute,
        private router: Router,
        private changeDeviceService: ChangeDeviceService,
        private changeStepService: ChangeStepService,
        private personalDataService: PersonalDataService,
        private fb: FormBuilder,
    ) {
        this.changeStepService.changeStep(7);
    }

    ngOnInit() {
        this.isPortraitDevice = this.changeDeviceService.isPortraitDevice;
        this.changeDeviceService.changedDevice.subscribe((value) => {
            this.isPortraitDevice = value;
        });

        this.getHouseTypes();
        this.createForm();
        this.setValuesForm(this.appData.data.userData.houseType);

        this.formIsValid();

        this.formGroup.markAsPristine();
    }

    createForm() {
        this.formGroup = this.fb.group({
            typeHousingContract: new FormControl(this.selectedTypeHousingContract ? this.selectedTypeHousingContract.code : 'P', [Validators.required]),
            year: new FormControl('', [
                Validators.required,
                Validators.minLength(4),
                Validators.maxLength(4),
                Validators.pattern(/^-?(0|[1-9]\d*)?$/),
            ]),
            cost: new FormControl('', [Validators.required, Validators.min(0), Validators.minLength(1), Validators.pattern(/^-?(0|[1-9]\d*)?$/)]),
        });
    }

    setValuesForm(value?: any) {
        if (value != undefined) {
            this.formGroup = this.fb.group({
                typeHousingContract: new FormControl(value.typeHousingContract ? value.typeHousingContract : 'P'),
                year: new FormControl(value.year ? value.year : '', [
                    Validators.required,
                    Validators.minLength(4),
                    Validators.maxLength(4),
                    Validators.pattern(/^-?(0|[1-9]\d*)?$/),
                ]),
                cost: new FormControl(value.cost ? value.cost : null, [Validators.required, Validators.min(0), Validators.minLength(1), Validators.pattern(/^-?(0|[1-9]\d*)?$/)]),
            });
        }
    }

    getHouseTypes() {
        this.personalDataService.getHouseTypes().subscribe({
            next: (response) => {
                this.houseTypes = response.filter (a => a.code == 'A' || a.code == 'P');
                this.houseTypesExtra = response;
                this.typeHousingOptions = this.houseTypes;
            },
            error: (error) => console.log(error),
        });
    }

    //-------------------------//
    //--------On changes-------//
    //-------------------------//

    onChangeTypeHousingContract(event: SelectButtonOptionClickEvent) {
        this.selectedTypeHousingContract = event.option;
        this.formIsValid();
    }

    onChangeYear(event: Event) {
        this.formIsValid();
    }

    onChangeCost(event: Event) {
        this.formIsValid();
    }

    onClickHouseType (event:boolean) {
        if(event){
            this.typeHousingOptions = this.houseTypesExtra;
        } else {
            this.typeHousingOptions = this.houseTypes;
        }

        this.showMoreHouseType = event;
    }

    //-------------------------//
    //-------VALIDATION--------//
    //-------------------------//

    formIsValid() {
        this.continueButtonDisabled = !this.formGroup.valid;
    }

    //-------------------------//
    //--------NAVIGATION-------//
    //-------------------------//

    onClicButtonBack() {
        this.saveDataService.saveDataLocal(this.formGroup.value, 'house-type');
        this.router.navigate(['/main/step/house-address'], { relativeTo: this.route });
    }

    onClicButtonContinue() {
        this.saveDataService.saveDataLocal(this.formGroup.value, 'house-type');
        //this.router.navigate(['/main/co-holder'], { relativeTo: this.route });
        this.router.navigate(['/main/step/working-situation'], { relativeTo: this.route });
    }

    ngOnDestroy() {}
}
